export const LiveTopIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <g clipPath="url(#clip0_24579_45198)">
      <path
        d="M14.5055 3.27398C14.4284 3.03715 14.2236 2.86441 13.9774 2.82867L11.6343 2.48812L10.586 0.364609C10.4762 0.141406 10.2487 0 9.99953 0C9.75035 0 9.52289 0.141406 9.41301 0.364609L8.36476 2.48816L6.02125 2.82871C5.77504 2.86449 5.57016 3.03719 5.49308 3.27402C5.41601 3.51086 5.48031 3.7709 5.65879 3.94469L7.35492 5.59758L6.95414 7.93133C6.91195 8.17688 7.01293 8.425 7.21441 8.57133C7.41633 8.71828 7.6834 8.73637 7.90359 8.62117L9.99969 7.51926L12.0954 8.62117C12.3206 8.73934 12.5866 8.71496 12.7845 8.57133C12.986 8.42504 13.087 8.17691 13.0448 7.93156L12.6444 5.59758L14.3401 3.94469C14.5184 3.7709 14.5822 3.51082 14.5055 3.27398Z"
        fill="white"
      />
      <path
        d="M12.6148 9.96875H7.38082C7.01949 9.96875 6.72656 10.2617 6.72656 10.623V20.0006H13.2691V10.623C13.2691 10.2617 12.9761 9.96875 12.6148 9.96875Z"
        fill="white"
      />
      <path
        d="M0.837852 12.5859C0.476523 12.5859 0.183594 12.8789 0.183594 13.2402V19.4835C0.183594 19.7692 0.415195 20.0008 0.700859 20.0008H5.41762V12.5859H0.837852Z"
        fill="white"
      />
      <path
        d="M19.1618 15.2021H14.582V20H19.2988C19.5845 20 19.8161 19.7684 19.8161 19.4827V15.8564C19.816 15.4951 19.5231 15.2021 19.1618 15.2021Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_24579_45198">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
